import UrlPattern from 'url-pattern';

export default {
  props: {
    /**
      * Key/value pairs of path name and url pattern (see url-pattern node module)
      */
    routes: {type: Object, default: function() {
      return {}; // No routes by default
    }}
  },
  methods: {
    route(routeName, routeParams) {
      let pattern = new UrlPattern(this.routes[routeName]);
      return pattern.stringify(routeParams);
    }
  }
};
